import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
const PrivateRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading)
        return _jsx("div", { children: "Chargement..." });
    if (!user)
        return _jsx(Navigate, { to: "/login", replace: true });
    if (user.must_change_password &&
        location.pathname !== '/change-password' &&
        !location.pathname.startsWith('/activate-account')) {
        return _jsx(Navigate, { to: "/change-password", replace: true });
    }
    return children;
};
export default PrivateRoute;
